import { graphql, useStaticQuery } from 'gatsby';

import { TranslationMessagesQuery } from '../../generated/types/gatsby';

export function useTranslationMessages() {
  return useStaticQuery<TranslationMessagesQuery>(graphql`
    query TranslationMessages {
      de: stringTranslations(locale: "de") {
        id
        message
      }
      en: stringTranslations(locale: "en") {
        id
        message
      }
      fr: stringTranslations(locale: "fr") {
        id
        message
      }
      it: stringTranslations(locale: "it") {
        id
        message
      }
    }
  `);
}
